// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".as-link[data-v-5c9b9c35]{cursor:pointer}.max-100 img[data-v-5c9b9c35]{max-width:100%;max-height:100%}label[data-v-5c9b9c35]{font-weight:500;color:var(--body-color);margin-bottom:0;font-size:.8rem}", ""]);
// Exports
module.exports = exports;
